import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import {
  GET_ADDEMPLOYEE,
  GET_EMPLOYEEDETAILS,
  GET_EMPLOYEESLIST,
  GET_UPDATEEMPLOYEE,
} from "resources/actionTypes";
import {
  addEmployeeService,
  getEmployeeDetailsService,
  getEmployeeListService,
  updateEmployeeService,
} from "services/EmployeesService";
import { onLoaderTrigger } from "redux/actions/commonAction";

function* fetchGetEmployeesList(action) {
  const payload = action.payload || {};
  const employeesList = yield call(getEmployeeListService, payload);
  if (employeesList.success) {
    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_SUCCESS,
      employeesList: employeesList,
    });
  } else {
    yield put({
      type: GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_FAILED,
      message: employeesList.message,
    });
    toast.error(employeesList.message || "Fetching Employee Failed");
  }
}

export function* getEmployeesListWatcher() {
  yield takeEvery(
    GET_EMPLOYEESLIST.GET_EMPLOYEESLIST_REQUESTED,
    fetchGetEmployeesList
  );
}

function* fetchEmployeeDetails(action) {
  const payload = action.payload || {};
  const employeesDetails = yield call(getEmployeeDetailsService, payload);
  if (employeesDetails.success) {
    yield put({
      type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_SUCCESS,
      employeesDetails: employeesDetails,
    });
  } else {
    yield put({
      type: GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_FAILED,
      message: employeesDetails.message,
    });
    toast.error(employeesDetails.message || "fetching Employee Details Failed");
  }
}

export function* getEmployeeDetailsWatcher() {
  yield takeEvery(
    GET_EMPLOYEEDETAILS.GET_EMPLOYEEDETAILS_REQUESTED,
    fetchEmployeeDetails
  );
}

function* fetchAddEmployee(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const frontdeskAddEmployee = yield call(
    addEmployeeService,
    payload.employeeData
  );
  if (frontdeskAddEmployee?.success) {
    yield put({ type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_SUCCESS });
    toast.success(frontdeskAddEmployee.message);
    store.dispatch(onLoaderTrigger(false));
    payload.navigate("/front-desk/employeeProfiles", {
      state: { tab: "employeeProfiles" },
    });
  } else {
    yield put({
      type: GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_FAILED,
      message: frontdeskAddEmployee.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(frontdeskAddEmployee.message || "Add Employee Failed");
  }
}

export function* addEmployeeSaga() {
  yield takeEvery(GET_ADDEMPLOYEE.GET_ADDEMPLOYEE_REQUESTED, fetchAddEmployee);
}

function* fetchUpdateEmployee(action) {
  store.dispatch(onLoaderTrigger(true));
  const payload = action.payload || {};
  const frontdeskUpdateEmployee = yield call(
    updateEmployeeService,
    payload.employeeData,
    payload.employeeId
  );
  if (frontdeskUpdateEmployee?.success) {
    yield put({ type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_SUCCESS });
    toast.success(frontdeskUpdateEmployee.message);
    store.dispatch(onLoaderTrigger(false));
    payload.navigate("/front-desk/employeeProfiles", {
      state: { tab: "employeeProfiles" },
    });
  } else {
    yield put({
      type: GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_FAILED,
      message: frontdeskUpdateEmployee.message,
    });
    store.dispatch(onLoaderTrigger(false));
    toast.error(frontdeskUpdateEmployee.message || "Updating Employee Failed");
  }
}

export function* updateEmployeeSaga() {
  yield takeEvery(
    GET_UPDATEEMPLOYEE.GET_UPDATEEMPLOYEE_REQUESTED,
    fetchUpdateEmployee
  );
}
